import { render, staticRenderFns } from "./ByHandPage.vue?vue&type=template&id=74fbb692&"
import script from "./ByHandPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./ByHandPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ByHandPage.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports